goog.provide("shadow.js.shim.module$date_fns$locale$ja$default");
shadow.js.shim.module$date_fns$locale$ja$default = esm_import$date_fns$locale$ja.default;
